var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.86,250.21l-118.12-1.14L157,248.9l-9.74,0-2.53,0a7,7,0,0,0-.86,0,4.73,4.73,0,0,0,.86.06l2.53.06,9.73.12,35.8.2,118.12.07c46.11,0,87.86.06,118.08.28,15.11.11,27.34.25,35.79.42,4.23.08,7.51.16,9.73.25a17.39,17.39,0,0,1,3.4.26,18,18,0,0,1-3.4.22c-2.22.06-5.51.12-9.73.15-8.46.08-20.69.1-35.8,0C398.71,251.05,357,250.69,310.86,250.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.94,260.62l-116.5-19.49L158.1,235.4l-9.62-1.49-2.5-.35a4.67,4.67,0,0,0-.86-.09,4.89,4.89,0,0,0,.84.19l2.49.46,9.59,1.63,35.33,5.76,116.68,18.42c45.55,7.15,86.78,13.7,116.6,18.61,14.91,2.46,27,4.5,35.29,6,4.17.74,7.39,1.33,9.58,1.76a18.63,18.63,0,0,1,3.31.79,17.87,17.87,0,0,1-3.39-.3c-2.21-.29-5.46-.74-9.64-1.36-8.36-1.24-20.45-3.12-35.37-5.51C396.59,275.11,355.41,268.26,309.94,260.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.4,270.75l-112-37.59-34-11.23-9.26-3-2.42-.75a6.93,6.93,0,0,0-.84-.22,4.8,4.8,0,0,0,.8.33l2.39.84,9.22,3.13,34,11.25,112.32,36.56c43.85,14.23,83.54,27.19,112.22,36.74,14.33,4.77,25.92,8.69,33.91,11.46,4,1.38,7.08,2.48,9.17,3.25a17.71,17.71,0,0,1,3.15,1.3,17.94,17.94,0,0,1-3.3-.83c-2.14-.63-5.28-1.59-9.31-2.86-8.06-2.54-19.7-6.3-34.06-11C390.68,298.72,351.1,285.46,307.4,270.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3,280.35,198.63,225.61l-31.8-16.43-8.68-4.41-2.27-1.11a4.65,4.65,0,0,0-.79-.35,6.48,6.48,0,0,0,.74.44l2.22,1.21,8.61,4.53L198.45,226l105.17,53.79c41.06,21,78.22,40,105,53.94,13.41,7,24.24,12.66,31.69,16.65,3.73,2,6.61,3.57,8.55,4.66a18.21,18.21,0,0,1,2.9,1.77,17.71,17.71,0,0,1-3.12-1.34c-2-1-5-2.4-8.74-4.29-7.56-3.78-18.47-9.32-31.9-16.24C381.15,321.07,344.14,301.75,303.3,280.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.75,289.19l-94.83-70.43-28.85-21.2-7.88-5.71-2.07-1.46a7.5,7.5,0,0,0-.72-.47,4.15,4.15,0,0,0,.66.56l2,1.54,7.8,5.82,28.82,21.23,95.47,69.56c37.28,27.12,71,51.74,95.31,69.7,12.15,9,22,16.3,28.69,21.4,3.37,2.55,6,4.56,7.72,5.94a16.85,16.85,0,0,1,2.59,2.2,17.82,17.82,0,0,1-2.88-1.81c-1.83-1.26-4.52-3.15-8-5.61-6.88-4.91-16.78-12.09-29-21C368.27,341.58,334.74,316.71,297.75,289.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.88,297.06l-82.72-84.32L183,187.31l-6.9-6.87-1.82-1.76a5.33,5.33,0,0,0-.64-.58,4.92,4.92,0,0,0,.57.65l1.74,1.83,6.8,7L207.89,213c21.39,21.4,50.89,50.94,83.49,83.57s62.09,62.15,83.3,83.67c10.61,10.77,19.16,19.51,25,25.61,2.93,3,5.19,5.42,6.7,7.06a17.77,17.77,0,0,1,2.22,2.58,17.37,17.37,0,0,1-2.56-2.24c-1.62-1.53-4-3.81-7-6.78-6-5.92-14.7-14.55-25.35-25.27C352.4,359.77,323.14,330,290.88,297.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.88,303.76l-68.6-96.17-20.93-29-5.75-7.86-1.52-2a4.39,4.39,0,0,0-.55-.67,6.73,6.73,0,0,0,.47.73l1.44,2.08,5.62,7.94L214,207.82l69.48,95.53c27.14,37.27,51.67,71,69.27,95.62,8.81,12.28,15.89,22.25,20.73,29.18,2.43,3.46,4.29,6.17,5.53,8a18,18,0,0,1,1.78,2.89,17.29,17.29,0,0,1-2.18-2.61c-1.36-1.76-3.33-4.38-5.85-7.78-5-6.79-12.26-16.66-21.11-28.91C333.9,375.28,309.63,341.31,282.88,303.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.93,309.13c-20.58-41.28-39.21-78.63-52.72-105.71l-16.13-31.95-4.45-8.66-1.19-2.24a5.83,5.83,0,0,0-.43-.74,4.56,4.56,0,0,0,.34.79l1.09,2.29c1,2,2.46,5,4.32,8.72l16.11,32,53.68,105.23c21,41.05,39.93,78.25,53.48,105.27,6.78,13.5,12.22,24.46,15.91,32.06,1.85,3.8,3.27,6.76,4.2,8.78a16.45,16.45,0,0,1,1.31,3.14,18.38,18.38,0,0,1-1.74-2.92c-1.07-1.95-2.61-4.85-4.57-8.6-3.91-7.49-9.5-18.37-16.33-31.85C313.14,387.75,294.47,350.4,273.93,309.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.25,313c-13.84-44-26.35-83.82-35.43-112.69-4.6-14.37-8.32-26-10.91-34.09-1.31-4-2.33-7.1-3-9.25-.35-1-.62-1.82-.82-2.39a5.58,5.58,0,0,0-.31-.81,4.35,4.35,0,0,0,.21.84l.72,2.43,2.89,9.29,10.88,34.1,36.46,112.36c14.27,43.84,27.12,83.56,36.26,112.37,4.56,14.4,8.21,26.08,10.66,34.17,1.23,4,2.16,7.19,2.77,9.33a18.1,18.1,0,0,1,.8,3.31,17.07,17.07,0,0,1-1.27-3.16c-.75-2.09-1.81-5.2-3.16-9.21-2.68-8-6.48-19.64-11.11-34C290.6,396.84,278,357,264.25,313Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.07,315.36,236.81,198.5c-2.28-14.92-4.12-27-5.4-35.38-.67-4.15-1.19-7.38-1.54-9.61l-.43-2.5a4.89,4.89,0,0,0-.19-.84,7,7,0,0,0,.08.86c.08.59.19,1.43.33,2.51.33,2.23.79,5.47,1.39,9.63,1.28,8.39,3.11,20.47,5.38,35.39,4.7,29.89,11.17,71.13,18.33,116.69S268.39,402,272.88,431.93c2.24,14.94,4,27.05,5.16,35.42.57,4.19,1,7.44,1.26,9.65a18,18,0,0,1,.27,3.4,18.09,18.09,0,0,1-.75-3.32c-.41-2.19-1-5.42-1.67-9.59-1.39-8.34-3.32-20.42-5.62-35.35C266.9,402.27,260.77,361,254.07,315.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.65,316.07c.42-46.13.79-87.87,1.07-118.12.06-15.1.11-27.31.15-35.8,0-4.2,0-7.47,0-9.73,0-1.09,0-1.93,0-2.53a4.52,4.52,0,0,0-.05-.87,8.47,8.47,0,0,0-.05.87c0,.6,0,1.44-.06,2.53,0,2.26-.07,5.53-.12,9.73,0,8.48-.1,20.7-.17,35.8V316.07c0,46.1,0,87.85-.21,118.07-.1,15.12-.23,27.35-.39,35.8-.08,4.22-.16,7.5-.25,9.73a18,18,0,0,1-.25,3.39,17.26,17.26,0,0,1-.23-3.39c-.06-2.23-.12-5.51-.16-9.74-.08-8.45-.1-20.68-.07-35.79C242.86,403.91,243.2,362.17,243.65,316.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.24,315.15c7.58-45.5,14.44-86.67,19.42-116.51,2.4-14.9,4.35-27,5.71-35.34.64-4.16,1.13-7.39,1.48-9.62.15-1.08.27-1.91.35-2.51a4.54,4.54,0,0,0,.09-.86,4.14,4.14,0,0,0-.19.84l-.46,2.5c-.37,2.22-.92,5.45-1.63,9.59-1.36,8.38-3.31,20.44-5.73,35.33-4.7,29.89-11.18,71.13-18.35,116.7s-13.64,86.78-18.54,116.61c-2.45,14.91-4.48,27-5.95,35.29-.74,4.16-1.33,7.39-1.76,9.58a18.22,18.22,0,0,1-.78,3.31,16.85,16.85,0,0,1,.3-3.39c.28-2.21.73-5.46,1.35-9.64,1.23-8.36,3.1-20.45,5.49-35.37C218.8,401.81,225.63,360.62,233.24,315.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.11,312.62l37.52-112c4.73-14.34,8.55-25.94,11.2-34,1.29-4,2.29-7.12,3-9.27l.75-2.42a4.39,4.39,0,0,0,.21-.83,6.62,6.62,0,0,0-.32.8l-.84,2.39c-.72,2.14-1.77,5.23-3.12,9.21-2.66,8.06-6.49,19.66-11.23,34L223.77,312.84c-14.2,43.86-27.13,83.56-36.67,112.24-4.76,14.34-8.67,25.93-11.44,33.92-1.38,4-2.47,7.09-3.24,9.17a17.28,17.28,0,0,1-1.3,3.15A17.94,17.94,0,0,1,172,468c.62-2.14,1.58-5.28,2.85-9.31,2.53-8.06,6.29-19.7,11-34.07C195.19,395.92,208.43,356.32,223.11,312.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.5,308.53c21.35-40.89,40.68-77.89,54.68-104.71L284.59,172l4.4-8.69,1.12-2.27a7.32,7.32,0,0,0,.35-.79,5.08,5.08,0,0,0-.45.74l-1.2,2.23c-1.05,2-2.58,4.89-4.53,8.61l-16.44,31.8-53.72,105.2c-20.94,41.08-40,78.25-53.88,105.07-7,13.41-12.65,24.24-16.63,31.7-2,3.73-3.56,6.61-4.65,8.55a18.73,18.73,0,0,1-1.77,2.91,17.21,17.21,0,0,1,1.34-3.13c1-2,2.4-5,4.28-8.74,3.78-7.57,9.32-18.47,16.22-31.91C172.84,386.4,192.13,349.38,213.5,308.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.66,303,275,208.1l21.19-28.85c2.46-3.41,4.37-6.06,5.7-7.89l1.46-2.07a7.5,7.5,0,0,0,.47-.72,4.15,4.15,0,0,0-.56.66c-.36.48-.87,1.14-1.54,2l-5.82,7.8-21.2,28.84c-17.81,24.46-42.37,58.21-69.51,95.51s-51.69,71-69.64,95.35c-9,12.16-16.28,22-21.38,28.71-2.55,3.37-4.55,6-5.93,7.72a18.38,18.38,0,0,1-2.2,2.59,16.93,16.93,0,0,1,1.81-2.88c1.26-1.83,3.14-4.52,5.6-8,4.9-6.88,12.08-16.79,21-29C152.32,373.54,177.17,340,204.66,303Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.79,296.12l84.27-82.78,25.42-25.21,6.86-6.9,1.76-1.82a4.59,4.59,0,0,0,.57-.64,5.67,5.67,0,0,0-.64.57l-1.84,1.75-7,6.79-25.43,25.2-83.52,83.53c-32.57,32.63-62.11,62.13-83.62,83.36-10.76,10.62-19.5,19.17-25.59,25-3,2.94-5.42,5.2-7.06,6.71a17.77,17.77,0,0,1-2.58,2.22,18.2,18.2,0,0,1,2.24-2.56c1.53-1.62,3.81-4,6.77-7,5.92-6,14.55-14.7,25.26-25.37C134.12,357.68,163.88,328.4,196.79,296.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.09,288.12l96.12-68.66,29-21,7.85-5.75,2-1.52a5.56,5.56,0,0,0,.66-.55,5,5,0,0,0-.73.46L323,192.59,315,198.22l-29,20.93-95.49,69.53c-37.25,27.17-71,51.72-95.57,69.34-12.27,8.82-22.24,15.91-29.17,20.75-3.46,2.42-6.16,4.29-8,5.53a17.46,17.46,0,0,1-2.9,1.79,17.29,17.29,0,0,1,2.61-2.18c1.76-1.37,4.39-3.34,7.78-5.87,6.78-5,16.66-12.26,28.89-21.12C118.6,339.18,152.55,314.89,190.09,288.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.71,279.17l105.67-52.78,31.95-16.15,8.65-4.46,2.24-1.19a5.83,5.83,0,0,0,.74-.43,5,5,0,0,0-.79.34l-2.28,1.1-8.72,4.32-32,16.13L185,279.8c-41,21-78.23,40-105.23,53.54-13.5,6.79-24.46,12.23-32.06,15.93-3.8,1.86-6.76,3.27-8.78,4.21a17.36,17.36,0,0,1-3.14,1.31A19.46,19.46,0,0,1,38.73,353c2-1.07,4.85-2.61,8.6-4.57,7.49-3.92,18.37-9.51,31.84-16.35C106.12,318.43,143.45,299.74,184.71,279.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.8,269.49,293.47,234l34.08-10.92,9.25-3,2.39-.82a4.8,4.8,0,0,0,.81-.32,6.93,6.93,0,0,0-.84.22l-2.42.72-9.3,2.89-34.09,10.9L181,270.16c-43.83,14.29-83.54,27.17-112.34,36.32-14.41,4.58-26.08,8.23-34.17,10.69-4,1.23-7.19,2.17-9.33,2.77a16,16,0,0,1-3.31.8A18.54,18.54,0,0,1,25,319.48c2.1-.75,5.2-1.82,9.21-3.17,8-2.69,19.63-6.5,34-11.14C97,295.89,136.82,283.32,180.8,269.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.47,259.32,295.31,242l35.39-5.43,9.6-1.55,2.5-.43a5.86,5.86,0,0,0,.84-.18,4.3,4.3,0,0,0-.86.07l-2.51.34-9.63,1.39-35.38,5.41L178.57,260C133,267.22,91.79,273.69,61.91,278.2c-14.94,2.25-27,4-35.42,5.18-4.19.58-7.44,1-9.65,1.27a17.94,17.94,0,0,1-3.4.27,18.39,18.39,0,0,1,3.32-.75c2.19-.41,5.42-1,9.59-1.68,8.34-1.4,20.42-3.33,35.35-5.64C91.57,272.21,132.86,266.05,178.47,259.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.75,248.9l118.12,1,35.8.13,9.73,0,2.53,0a6.06,6.06,0,0,0,.87,0,4.93,4.93,0,0,0-.87-.06l-2.53-.05-9.73-.11-35.8-.15-118.12.07c-46.1.06-87.85.05-118.07-.14-15.12-.09-27.35-.21-35.8-.37-4.22-.07-7.51-.15-9.73-.24a17.88,17.88,0,0,1-3.39-.25,18.33,18.33,0,0,1,3.39-.23c2.23-.06,5.51-.12,9.74-.16,8.45-.09,20.68-.12,35.79-.1C89.9,248.16,131.65,248.48,177.75,248.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.66,238.49l116.53,19.34,35.34,5.69,9.62,1.47,2.51.36a4.94,4.94,0,0,0,.86.08,5.63,5.63,0,0,0-.85-.19l-2.49-.45-9.59-1.63-35.34-5.71-116.7-18.27c-45.56-7.1-86.8-13.59-116.62-18.47-14.92-2.43-27-4.46-35.31-5.93-4.16-.73-7.39-1.32-9.57-1.75a17.62,17.62,0,0,1-3.31-.78,16.85,16.85,0,0,1,3.39.3c2.21.28,5.46.73,9.64,1.34,8.36,1.23,20.45,3.1,35.37,5.47C92,224.11,133.18,230.91,178.66,238.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.19,228.35l112,37.46,34,11.18,9.27,3,2.42.74a5.21,5.21,0,0,0,.83.22,4,4,0,0,0-.8-.32l-2.39-.84-9.22-3.12-34-11.21L181,229c-43.87-14.18-83.58-27.08-112.26-36.6-14.35-4.75-25.94-8.66-33.93-11.42-4-1.38-7.09-2.47-9.18-3.24a18.32,18.32,0,0,1-3.15-1.29,17.06,17.06,0,0,1,3.3.82c2.14.63,5.28,1.59,9.31,2.85,8.07,2.53,19.71,6.27,34.08,11C97.87,200.49,137.47,213.7,181.19,228.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.27,218.75,290,273.36l31.82,16.39,8.68,4.39,2.28,1.12a7.32,7.32,0,0,0,.79.35,5.72,5.72,0,0,0-.75-.45l-2.22-1.2L322,289.43,290.19,273,185,219.36c-41.09-20.91-78.27-39.9-105.1-53.81-13.42-7-24.26-12.63-31.71-16.61-3.73-2-6.62-3.56-8.56-4.64a19.41,19.41,0,0,1-2.91-1.77,16.32,16.32,0,0,1,3.13,1.34c2,.95,5,2.39,8.75,4.28,7.56,3.76,18.47,9.29,31.92,16.19C107.37,178.13,144.41,197.4,185.27,218.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.82,209.9l94.92,70.31,28.86,21.17,7.9,5.69,2.06,1.46a5.17,5.17,0,0,0,.73.47,5.56,5.56,0,0,0-.66-.55l-2-1.54-7.81-5.82L286,279.91l-95.55-69.45c-37.32-27.07-71.07-51.64-95.4-69.58-12.17-9-22-16.26-28.72-21.36-3.37-2.55-6-4.55-7.73-5.93a16.85,16.85,0,0,1-2.59-2.2,17.82,17.82,0,0,1,2.88,1.81c1.84,1.26,4.53,3.14,8,5.6,6.88,4.9,16.79,12.07,29,21C120.22,157.61,153.79,182.43,190.82,209.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.67,202l82.83,84.21,25.22,25.4,6.91,6.86,1.82,1.76a5,5,0,0,0,.65.58,4.39,4.39,0,0,0-.57-.65l-1.75-1.83-6.81-7L280.77,286l-83.59-83.46C164.53,170,135,140.45,113.77,119c-10.63-10.75-19.18-19.49-25-25.58-2.94-3-5.2-5.42-6.71-7.05a17,17,0,0,1-2.22-2.58A18.2,18.2,0,0,1,82.35,86c1.62,1.53,4,3.81,7,6.76,6,5.92,14.71,14.54,25.38,25.25C136.07,139.39,165.37,169.13,197.67,202Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.67,195.32l68.72,96.07,21,29,5.76,7.84,1.52,2a5.31,5.31,0,0,0,.55.67,4.43,4.43,0,0,0-.46-.73l-1.44-2.08-5.64-7.93-20.95-29c-17.82-24.45-42.41-58.18-69.59-95.45s-51.76-71-69.4-95.52C126.88,87.93,119.79,78,114.94,71c-2.43-3.46-4.3-6.16-5.54-8a19.28,19.28,0,0,1-1.79-2.89,17.62,17.62,0,0,1,2.19,2.61c1.36,1.75,3.34,4.37,5.86,7.77,5,6.78,12.27,16.64,21.15,28.88C154.56,123.86,178.87,157.8,205.67,195.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.61,189.93c20.64,41.26,39.31,78.59,52.85,105.64l16.17,31.94,4.47,8.65,1.18,2.23a5.65,5.65,0,0,0,.44.75,4.56,4.56,0,0,0-.34-.79c-.26-.55-.63-1.3-1.1-2.29L284,327.35c-3.82-7.58-9.34-18.48-16.15-32L214,190.25c-21-41-40-78.21-53.62-105.2-6.79-13.5-12.24-24.45-16-32-1.85-3.8-3.27-6.76-4.21-8.78a16.89,16.89,0,0,1-1.31-3.13A18.26,18.26,0,0,1,140.65,44c1.07,2,2.61,4.85,4.57,8.6,3.93,7.48,9.52,18.36,16.38,31.83C175.3,111.36,194,148.69,214.61,189.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.28,186c13.9,44,26.47,83.79,35.58,112.64,4.61,14.37,8.35,26,10.95,34.08,1.31,4,2.34,7.1,3,9.25.36,1,.63,1.82.82,2.39a4,4,0,0,0,.32.8,6.11,6.11,0,0,0-.21-.83c-.18-.58-.42-1.38-.73-2.43l-2.9-9.29c-2.59-8.08-6.32-19.71-10.92-34.09-9.38-28.76-22.31-68.45-36.61-112.31s-27.23-83.52-36.39-112.32c-4.59-14.4-8.25-26.07-10.72-34.16-1.23-4-2.17-7.19-2.77-9.33a17.79,17.79,0,0,1-.81-3.3,17.12,17.12,0,0,1,1.27,3.15c.76,2.1,1.82,5.2,3.17,9.21,2.7,8,6.52,19.63,11.16,34C197.83,102.25,210.44,142.05,224.28,186Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.46,183.68c6.8,45.62,12.95,86.91,17.41,116.83,2.29,14.92,4.16,27,5.45,35.38l1.55,9.61c.19,1.08.33,1.9.43,2.5a5.24,5.24,0,0,0,.19.84,7,7,0,0,0-.08-.86c-.08-.6-.19-1.43-.34-2.51-.32-2.24-.79-5.47-1.4-9.63-1.29-8.39-3.14-20.47-5.42-35.38-4.74-29.89-11.26-71.12-18.48-116.67S220,97,215.51,67.13c-2.27-14.94-4-27-5.21-35.41-.58-4.19-1-7.44-1.27-9.66a17.49,17.49,0,0,1-.28-3.39,17.45,17.45,0,0,1,.76,3.32c.41,2.19,1,5.42,1.68,9.59,1.4,8.34,3.34,20.41,5.67,35.34C221.52,96.79,227.7,138.07,234.46,183.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.88,183c-.36,46.12-.68,87.86-.92,118.12,0,15.09-.08,27.31-.1,35.8,0,4.2,0,7.47,0,9.73,0,1.09,0,1.93,0,2.53a7,7,0,0,0,0,.86,4.73,4.73,0,0,0,.06-.86c0-.6,0-1.44.05-2.53,0-2.26.06-5.53.11-9.73,0-8.49.07-20.71.13-35.8,0-30.26-.09-72-.15-118.12s-.11-87.86.06-118.08c.08-15.11.2-27.34.35-35.79.07-4.23.15-7.51.23-9.74a18,18,0,0,1,.25-3.39,17.32,17.32,0,0,1,.23,3.4c.07,2.22.13,5.5.17,9.73.09,8.45.14,20.68.12,35.8C245.56,95.11,245.27,136.86,244.88,183Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.29,183.86C247.76,229.37,241,270.55,236,300.4c-2.39,14.9-4.32,27-5.66,35.35-.64,4.15-1.13,7.38-1.47,9.62-.15,1.08-.27,1.91-.35,2.5a6.2,6.2,0,0,0-.09.86,3.9,3.9,0,0,0,.19-.84q.17-.88.45-2.49c.38-2.23.92-5.45,1.62-9.6,1.35-8.37,3.29-20.44,5.69-35.34,4.66-29.89,11.09-71.14,18.2-116.71S268.13,96.94,273,67.11c2.43-14.91,4.45-27,5.91-35.3.73-4.16,1.32-7.39,1.74-9.58a18.22,18.22,0,0,1,.78-3.31,17.18,17.18,0,0,1-.29,3.39c-.28,2.21-.73,5.46-1.34,9.64-1.22,8.37-3.08,20.45-5.45,35.38C269.62,97.18,262.84,138.38,255.29,183.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.43,186.38c-14.6,43.75-27.81,83.35-37.38,112.05-4.71,14.34-8.52,25.95-11.16,34-1.28,4-2.28,7.12-3,9.27-.32,1.05-.56,1.85-.74,2.42a6.93,6.93,0,0,0-.22.84,4.41,4.41,0,0,0,.32-.8l.84-2.39,3.11-9.22,11.19-34,36.34-112.39c14.15-43.88,27-83.59,36.53-112.29,4.74-14.34,8.64-25.94,11.39-33.93,1.38-4,2.47-7.09,3.24-9.18a16.93,16.93,0,0,1,1.29-3.15,16.94,16.94,0,0,1-.83,3.3c-.62,2.14-1.57,5.28-2.84,9.31-2.52,8.07-6.25,19.72-10.94,34.09C293.23,103,280.05,142.66,265.43,186.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,190.46,220.49,295.24l-16.37,31.83-4.39,8.69L198.62,338a6,6,0,0,0-.35.79,4.1,4.1,0,0,0,.44-.74l1.21-2.23c1-2,2.56-4.9,4.52-8.62l16.39-31.82c13.73-27,32.66-64.16,53.59-105.27S314.27,111.85,328.16,85c6.95-13.42,12.62-24.26,16.59-31.72,2-3.73,3.56-6.62,4.64-8.56a17.22,17.22,0,0,1,1.77-2.91A18.2,18.2,0,0,1,349.82,45c-.95,2-2.39,5-4.27,8.75-3.76,7.57-9.29,18.48-16.18,31.93C315.6,112.53,296.35,149.58,275,190.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,196l-70.26,95-21.14,28.88-5.69,7.9-1.46,2.07a7.5,7.5,0,0,0-.47.72,3.91,3.91,0,0,0,.55-.66l1.54-2,5.81-7.81c5-6.84,12.25-16.69,21.17-28.87l69.38-95.59c27.05-37.34,51.6-71.11,69.52-95.44,9-12.18,16.25-22,21.35-28.74,2.54-3.37,4.54-6,5.92-7.73a16.85,16.85,0,0,1,2.2-2.59A17.82,17.82,0,0,1,380.5,64c-1.26,1.84-3.14,4.53-5.59,8-4.9,6.89-12.06,16.8-21,29C336.13,125.37,311.33,159,283.89,196Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.76,202.85,207.6,285.73,182.21,311c-3,3-5.26,5.31-6.85,6.91-.75.79-1.34,1.39-1.76,1.82a5.13,5.13,0,0,0-.57.65,6.18,6.18,0,0,0,.65-.57l1.83-1.75,7-6.81L207.86,286l83.41-83.65c32.53-32.67,62-62.21,83.52-83.46,10.74-10.63,19.47-19.2,25.56-25.07,3-2.93,5.41-5.2,7-6.71A17.59,17.59,0,0,1,410,84.89a17.37,17.37,0,0,1-2.24,2.56c-1.52,1.62-3.8,4-6.75,7-5.92,6-14.53,14.72-25.23,25.39C354.36,141.21,324.64,170.52,291.76,202.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.48,210.84l-96,68.78-29,21-7.85,5.77-2,1.52a5.19,5.19,0,0,0-.67.55,5.56,5.56,0,0,0,.73-.46l2.08-1.45,7.93-5.64,29-21c24.43-17.85,58.15-42.46,95.4-69.66s70.95-51.8,95.48-69.46C405.82,132,415.78,124.88,422.7,120c3.46-2.43,6.16-4.3,8-5.54a17.46,17.46,0,0,1,2.9-1.79,17.29,17.29,0,0,1-2.61,2.18c-1.76,1.37-4.38,3.35-7.77,5.87-6.78,5-16.64,12.29-28.87,21.17C369.9,159.68,336,184,298.48,210.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.87,219.78,198.26,272.69l-31.92,16.2-8.65,4.47-2.23,1.19a5.63,5.63,0,0,0-.75.43,4.56,4.56,0,0,0,.79-.34l2.28-1.1,8.72-4.33L198.43,273l105.12-53.89c41-21.06,78.18-40.07,105.17-53.68,13.49-6.8,24.44-12.26,32-16,3.8-1.86,6.76-3.28,8.78-4.22a17.36,17.36,0,0,1,3.14-1.31,19.46,19.46,0,0,1-2.92,1.75c-1.95,1.07-4.85,2.62-8.59,4.58-7.48,3.93-18.36,9.54-31.82,16.39C382.41,180.42,345.1,199.15,303.87,219.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.79,229.45,195.17,265.09l-34.07,11-9.25,3.05-2.39.82a4,4,0,0,0-.8.32,7.86,7.86,0,0,0,.83-.22l2.43-.72,9.29-2.91,34.08-11,112.28-36.67c43.82-14.35,83.51-27.28,112.31-36.47,14.39-4.6,26.06-8.26,34.14-10.74,4.05-1.23,7.19-2.17,9.33-2.78a16,16,0,0,1,3.31-.8,18.48,18.48,0,0,1-3.16,1.27c-2.09.75-5.2,1.82-9.2,3.17-8,2.71-19.63,6.53-34,11.19C391.54,202.94,351.75,215.57,307.79,229.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.13,239.62,193.31,257.11l-35.37,5.47-9.61,1.56-2.5.43a5.24,5.24,0,0,0-.84.19,7,7,0,0,0,.86-.08l2.51-.34,9.63-1.41,35.38-5.45L310,238.93c45.52-7.27,86.76-13.79,116.64-18.34,14.94-2.27,27-4.05,35.41-5.22,4.19-.59,7.44-1,9.65-1.28a17.53,17.53,0,0,1,3.39-.28,18.19,18.19,0,0,1-3.31.76c-2.19.41-5.42,1-9.59,1.69-8.34,1.4-20.41,3.35-35.34,5.69C397,226.62,355.73,232.84,310.13,239.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.45,72.36l1.05,1.74a11.91,11.91,0,0,0,4.94,4.55l1.83.9-1.75,1A12.11,12.11,0,0,0,359,85.54l-.9,1.83L357,85.62a11.93,11.93,0,0,0-4.93-4.54l-1.83-.91,1.74-1a11.89,11.89,0,0,0,4.55-4.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.28,276.89l.64,1.07a7.3,7.3,0,0,0,3,2.78l1.12.55-1.07.65a7.24,7.24,0,0,0-2.78,3l-.55,1.11L355,285a7.32,7.32,0,0,0-3-2.79l-1.11-.55,1.06-.64a7.32,7.32,0,0,0,2.79-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.42,389.62l.64,1.06a7.23,7.23,0,0,0,3,2.78l1.11.56-1.06.64a7.3,7.3,0,0,0-2.78,3l-.56,1.12-.64-1.07a7.3,7.3,0,0,0-3-2.78l-1.11-.56,1.06-.64a7.3,7.3,0,0,0,2.78-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.05,335l.64,1.06a7.3,7.3,0,0,0,3,2.78l1.11.56-1.06.64a7.23,7.23,0,0,0-2.78,3l-.56,1.11-.64-1.06a7.3,7.3,0,0,0-3-2.78l-1.12-.56,1.07-.64a7.3,7.3,0,0,0,2.78-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.64,36.91l.64,1.07a7.36,7.36,0,0,0,3,2.78l1.11.55-1.06.64a7.3,7.3,0,0,0-2.78,3L182,46.09,181.37,45a7.36,7.36,0,0,0-3-2.78l-1.11-.55,1.06-.64a7.3,7.3,0,0,0,2.78-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,47.39l.64,1.07a7.3,7.3,0,0,0,3,2.78l1.12.56-1.07.64a7.36,7.36,0,0,0-2.78,3l-.55,1.11-.64-1.06a7.23,7.23,0,0,0-3-2.78l-1.12-.56,1.07-.64a7.3,7.3,0,0,0,2.78-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.88,151.56l.64,1.06a7.32,7.32,0,0,0,3,2.79l1.12.55-1.07.64a7.3,7.3,0,0,0-2.78,3l-.56,1.12-.64-1.07a7.3,7.3,0,0,0-3-2.78l-1.11-.55,1.06-.65a7.24,7.24,0,0,0,2.78-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.58,180.68l.65,1.06a7.26,7.26,0,0,0,3,2.79l1.11.55-1.06.64a7.32,7.32,0,0,0-2.79,3l-.55,1.12-.64-1.07a7.3,7.3,0,0,0-3-2.78l-1.12-.55,1.07-.65a7.24,7.24,0,0,0,2.78-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.28,392.19l.64,1.07a7.3,7.3,0,0,0,3,2.78l1.12.55-1.07.65a7.24,7.24,0,0,0-2.78,3l-.55,1.11-.65-1.06a7.32,7.32,0,0,0-3-2.79l-1.11-.55,1.06-.64a7.32,7.32,0,0,0,2.79-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.39,80.4l1.29,2.15a14.74,14.74,0,0,0,6.1,5.61L180,89.28l-2.15,1.29a14.61,14.61,0,0,0-5.61,6.1l-1.12,2.25-1.29-2.16a14.8,14.8,0,0,0-6.1-5.61L161.51,90l2.15-1.3a14.67,14.67,0,0,0,5.62-6.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,69.69l1.29,2.15a14.74,14.74,0,0,0,6.09,5.62l2.26,1.11-2.16,1.29a14.8,14.8,0,0,0-5.61,6.1l-1.11,2.25-1.3-2.15a14.59,14.59,0,0,0-6.09-5.61l-2.25-1.12L443.24,78a14.74,14.74,0,0,0,5.61-6.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.28,36.13l.75,1.24a8.44,8.44,0,0,0,3.54,3.26l1.31.65-1.25.75a8.44,8.44,0,0,0-3.26,3.54l-.65,1.31L331,45.63a8.44,8.44,0,0,0-3.54-3.26l-1.3-.65,1.24-.75a8.44,8.44,0,0,0,3.26-3.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,290.28l1.13,1.88a12.85,12.85,0,0,0,5.34,4.91l2,1-1.89,1.13a12.91,12.91,0,0,0-4.91,5.34l-1,2-1.13-1.89a12.85,12.85,0,0,0-5.34-4.91l-2-1,1.89-1.14A12.88,12.88,0,0,0,74,292.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.17,399.54l1.13,1.89a12.85,12.85,0,0,0,5.34,4.91l2,1-1.89,1.13a12.85,12.85,0,0,0-4.91,5.34l-1,2-1.13-1.89a12.85,12.85,0,0,0-5.34-4.91l-2-1,1.89-1.13a12.85,12.85,0,0,0,4.91-5.34Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.56,478.22c0,.14-101.89.26-227.55.26s-227.57-.12-227.57-.26S124.31,478,250,478,477.56,478.07,477.56,478.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "325.13 435.8 323.93 433.98 178.24 429.02 159.61 478.17 334 477.96 325.13 435.8",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.13 435.8 323.93 433.98 178.24 429.02 159.61 478.17 334 477.96 325.13 435.8",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,301.43a6.64,6.64,0,0,0-3.13-5.21c-27.89-18.45-48.9-59.35-51-94q-.08-3-.18-6v0h0c-1.61-49.5-8.9-109.54-15.45-125.55-12.09-29.56-53-32.34-53-32.34-54.35-3.89-64,37.88-69.54,75.92-3.41,23.65-16.56,108.15-16.56,108.15l10,3.86c11.77,34.88,38.27,63.08,72.72,76,10,3.78,18.5,5.29,22.48,2.05a136.71,136.71,0,0,0,57.19,34.72c8.78,2.67,18,4.45,27.12,3.6,5.93-.56,12.18-2.52,15.72-7.31a13.64,13.64,0,0,0-11.69-21.71C381.69,307,395.24,309,395,301.43Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395,301.43a6.64,6.64,0,0,0-3.13-5.21c-27.89-18.45-48.9-59.35-51-94q-.08-3-.18-6v0h0c-1.61-49.5-8.9-109.54-15.45-125.55-12.09-29.56-53-32.34-53-32.34-54.35-3.89-64,37.88-69.54,75.92-3.41,23.65-16.56,108.15-16.56,108.15l10,3.86c11.77,34.88,38.27,63.08,72.72,76,10,3.78,18.5,5.29,22.48,2.05a136.71,136.71,0,0,0,57.19,34.72c8.78,2.67,18,4.45,27.12,3.6,5.93-.56,12.18-2.52,15.72-7.31a13.64,13.64,0,0,0-11.69-21.71C381.69,307,395.24,309,395,301.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.44,53.72,276,50.47,239.29,65.28a10.27,10.27,0,0,0-9.69,9.93l.33,119.73c-.05,8.12,1.58,15.15,6.48,21.62l5.16,6.81c11.77,15.54,36,14.26,45.29-2.86a13.14,13.14,0,0,0,1.3-3.09,26,26,0,0,0,.54-2.68c1.1-9.63,1.16-18,1.16-18,.65-10.57.87-14.91.87-14.81s22.51-2.59,28.59-31.48c3-14.37,2.46-34.13,1.61-53.58C319.75,70,301.08,53.69,279.44,53.72Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.9,113a3.73,3.73,0,0,1-3.79,3.59,3.57,3.57,0,0,1-3.68-3.56,3.75,3.75,0,0,1,3.79-3.59A3.58,3.58,0,0,1,271.9,113Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M309.89,114a3.74,3.74,0,0,1-3.79,3.58,3.57,3.57,0,0,1-3.68-3.56,3.73,3.73,0,0,1,3.78-3.59A3.59,3.59,0,0,1,309.89,114Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M317.08,104.57c-.48.46-3.21-1.77-7.23-2s-7.06,1.67-7.47,1.15c-.21-.22.31-1.08,1.64-2a10.27,10.27,0,0,1,6-1.53,9.87,9.87,0,0,1,5.73,2.17C317,103.46,317.32,104.36,317.08,104.57Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M276.3,105c-.53.41-3-2.1-7-2.7s-7.2.94-7.56.38c-.18-.24.42-1,1.84-1.77a10.25,10.25,0,0,1,6.14-.91,9.9,9.9,0,0,1,5.47,2.75C276.27,103.87,276.56,104.81,276.3,105Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M290.34,134.24c0-.23,2.51-.53,6.59-.85,1,0,2-.21,2.22-.9s-.1-1.86-.54-3.08l-2.64-8c-3.66-11.34-6.25-20.64-5.79-20.78s3.79,8.93,7.45,20.26c.88,2.8,1.72,5.46,2.51,8,.33,1.18.94,2.54.33,4.05a2.56,2.56,0,0,1-1.76,1.42,6.6,6.6,0,0,1-1.75.15C292.87,134.58,290.34,134.47,290.34,134.24Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290.73,181.94a74.2,74.2,0,0,1-38.48-12.36s8.8,20.65,38.08,19.39Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M288.15,143.84a7.23,7.23,0,0,0-6.35-3,6.6,6.6,0,0,0-4.69,2.22,4.2,4.2,0,0,0-.56,4.77c1,1.58,3.26,2.05,5.2,1.6a15.2,15.2,0,0,0,5.29-2.81,4.67,4.67,0,0,0,1.21-1.13,1.37,1.37,0,0,0,.07-1.5",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M288.15,143.84a7.23,7.23,0,0,0-6.35-3,6.6,6.6,0,0,0-4.69,2.22,4.2,4.2,0,0,0-.56,4.77c1,1.58,3.26,2.05,5.2,1.6a15.2,15.2,0,0,0,5.29-2.81,4.67,4.67,0,0,0,1.21-1.13,1.37,1.37,0,0,0,.07-1.5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M279.45,90.46c-.79.86-4.29-1.18-8.86-2.49s-8.59-1.61-8.78-2.76c-.08-.54.93-1.23,2.76-1.61a16,16,0,0,1,13.45,4C279.34,88.92,279.81,90.05,279.45,90.46Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M314.45,95c-.63,1-3.47.24-6.8.46s-6.09,1.09-6.81.19c-.32-.44.05-1.38,1.21-2.34a9.85,9.85,0,0,1,11-.54C314.27,93.61,314.73,94.52,314.45,95Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M230.34,126.31s20.58,6.4,32.23-44.4c4-17.37,20.09-31.44,20.09-31.44l-6.54-2s-40.59,11.44-41.27,12-10.24,21-10.24,21Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.41,124.42c.1-2.17-2.15-7.41-4.27-7.85-5.68-1.18-16-1.24-16.83,13.28-1.13,19.85,19,16.89,19.1,16.32S235.05,131.91,235.41,124.42Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M227.77,138.31c-.08-.07-.36.22-1,.45a3.41,3.41,0,0,1-2.58-.09c-2.06-.89-3.63-4.32-3.53-7.9a11.45,11.45,0,0,1,1.25-4.9,4,4,0,0,1,2.75-2.5,1.76,1.76,0,0,1,2,1.06c.23.57.08,1,.19,1s.44-.31.33-1.14a2.24,2.24,0,0,0-.71-1.29,2.61,2.61,0,0,0-1.88-.61c-1.54,0-3,1.35-3.79,2.87a11.63,11.63,0,0,0-1.51,5.47c-.1,4,1.73,7.86,4.55,8.85a3.72,3.72,0,0,0,3.2-.34C227.71,138.78,227.84,138.34,227.77,138.31Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M230.34,126.31s20.58,6.4,32.23-44.4c4-17.37,20.09-31.44,20.09-31.44l-6.54-2s-40.59,11.44-41.27,12-10.24,21-10.24,21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M278.37,136.43c.66,0,.45,4.36,4,7.64s8.24,3,8.25,3.65c0,.27-1.08.79-3,.75a10.87,10.87,0,0,1-6.9-2.8,9.48,9.48,0,0,1-3.09-6.39C277.54,137.44,278.08,136.39,278.37,136.43Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M278.37,136.43c.66,0,.45,4.36,4,7.64s8.24,3,8.25,3.65c0,.27-1.08.79-3,.75a10.87,10.87,0,0,1-6.9-2.8,9.48,9.48,0,0,1-3.09-6.39C277.54,137.44,278.08,136.39,278.37,136.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M434.29,137.71s26.53,53.38,31,64.6c3.9,9.71,25.46,55.2,18.79,67.82s-12.58,12-21.87,12.47-69.72-2-85.39-2.63c-19.93-.83-41.86-6.49-41.86-6.49l10.28-54.69,79.89,14.86h0l-13.5-86.79Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.44,138.11s-4.6-8.18-7.45-10.14-26-22.26-26-22.26-9.08-9.62-11.58-9.08S363.22,113,363,115.51s1.07,3.91,2.5,4.27-.72,2,3,5.7c0,0-3.56-.18-3.38,3.21s0,8,2.32,8.19,9.61,2.32,10-1.6l.71-1.61a69.8,69.8,0,0,0,11.94,6.77c5.7,2.32,14.78,2.14,14.78,2.14a10.56,10.56,0,0,0,6.77,4.28C415.94,147.39,434.44,138.11,434.44,138.11Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M398.94,123.48c-.08-.06-.86.84-1.24,2.68a11.24,11.24,0,0,0,1.06,7,21,21,0,0,0,4.27,5.66c1.29,1.25,2.16,1.94,2.25,1.85s-.62-.94-1.78-2.29a27.58,27.58,0,0,1-3.91-5.62,12.2,12.2,0,0,1-1.25-6.53C398.53,124.53,399.08,123.55,398.94,123.48Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M388,128.18c-.05,0,0,.2.19.39a1.56,1.56,0,0,0,1.1.3,4.39,4.39,0,0,0,3-1.78,5.19,5.19,0,0,0,1.1-3.29c-.05-.9-.35-1.4-.45-1.36s-.09.55-.2,1.33a6.14,6.14,0,0,1-1.18,2.76,4.77,4.77,0,0,1-2.38,1.7C388.52,128.43,388.14,128.11,388,128.18Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M396.92,105.52a2.65,2.65,0,0,0-2.27.18,5.84,5.84,0,0,0-2.12,1.7c-.68.82-1.27,1.84-2,2.91a84,84,0,0,1-5.38,7.3c-1.08,1.32-2.26,2.67-3.53,4a8.18,8.18,0,0,0-1.76,2.43,3.52,3.52,0,0,0,.34,3.2,10.8,10.8,0,0,0,2,2.29c.72.65,1.44,1.28,2.17,1.87a34.27,34.27,0,0,0,4.46,3.16,5.36,5.36,0,0,0,2.59.71,5,5,0,0,0,2.43-.72,8.53,8.53,0,0,0,3.11-3.09,4.17,4.17,0,0,0,.28-3.63,2.69,2.69,0,0,0-2.15-1.69,2.3,2.3,0,0,0-1.68.4c-.32.25-.4.45-.39.46a2.44,2.44,0,0,1,2-.51,2.31,2.31,0,0,1,1.73,1.54,3.66,3.66,0,0,1-.37,3.11,8.1,8.1,0,0,1-2.93,2.74,4.13,4.13,0,0,1-2.06.58,4.63,4.63,0,0,1-2.18-.64,34.88,34.88,0,0,1-4.29-3.12c-.71-.58-1.42-1.2-2.13-1.85A10.1,10.1,0,0,1,381,126.8a2.62,2.62,0,0,1-.28-2.4,7.5,7.5,0,0,1,1.57-2.15q1.9-2.07,3.53-4.1a72.56,72.56,0,0,0,5.27-7.49c.69-1.11,1.24-2.14,1.84-2.94a5.9,5.9,0,0,1,1.87-1.7A4.73,4.73,0,0,1,396.92,105.52Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M392.73,122.54c-.11.06,0,.48.39,1a4.66,4.66,0,0,0,2.13,1.55,4.73,4.73,0,0,0,2.63.19c.67-.17,1-.44,1-.54s-1.59.13-3.28-.51S393,122.4,392.73,122.54Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M387.59,102.31a8.3,8.3,0,0,0-1.36,1.41c-.83.94-2,2.32-3.44,4l-5,6.08-2.94,3.61a27.34,27.34,0,0,0-3,4.11,5.55,5.55,0,0,0-.37,5.2,10.84,10.84,0,0,0,3.37,3.43c2.39,1.78,4.4,3.49,6.38,4.71a6.63,6.63,0,0,0,3,1,4.47,4.47,0,0,0,2.32-.55c1.16-.69,1.3-1.54,1.26-1.52a4.37,4.37,0,0,1-1.43,1.2,4.15,4.15,0,0,1-2.12.36,6.19,6.19,0,0,1-2.68-1c-1.81-1.21-3.85-3-6.19-4.82a10.57,10.57,0,0,1-3.09-3.16,4.68,4.68,0,0,1,.39-4.37,28.12,28.12,0,0,1,2.87-4l2.9-3.64,4.86-6.21c1.38-1.77,2.48-3.22,3.22-4.23A7.52,7.52,0,0,0,387.59,102.31Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M379.87,104.14c-.23-.16-3.14,4.33-8,8.64a28.89,28.89,0,0,0-3.33,3.3,9.48,9.48,0,0,0-1.82,3.45c-.58,2.23.17,3.6.25,3.53a9.64,9.64,0,0,1,.38-3.34,9.34,9.34,0,0,1,1.85-3.1,33.5,33.5,0,0,1,3.29-3.15,38.27,38.27,0,0,0,5.66-6.29A10.42,10.42,0,0,0,379.87,104.14Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M368.68,129.53c0,.32,2.62,0,5.43.95a7.49,7.49,0,0,1,3.09,2.08c.64.73.89,1.32,1,1.27s.08-.72-.49-1.66a6.48,6.48,0,0,0-3.3-2.55,9.71,9.71,0,0,0-4.09-.49C369.29,129.22,368.67,129.41,368.68,129.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M425.38,233.1a9.36,9.36,0,0,0,1.23,3.05,36.56,36.56,0,0,0,4.4,6.58,37.41,37.41,0,0,0,5.7,5.51,9.66,9.66,0,0,0,2.78,1.75c.17-.23-3.88-3.16-7.77-7.85S425.63,233,425.38,233.1Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.61 279.17 375.66 224.44 381.85 225.59 374.71 279.86 366.61 279.17",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7,116.4s-26.53,53.39-31,64.6c-3.9,9.71-25.46,55.2-18.79,67.82s12.59,12,21.87,12.47,69.72-2,85.39-2.63c19.94-.83,41.86-6.49,41.86-6.49l-10.28-54.69L72.83,212.34h0l13.49-86.79Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.55,116.8s4.61-8.17,7.46-10.13S97,84.4,97,84.4s9.08-9.62,11.58-9.08S134.77,91.7,135,94.2s-1.07,3.92-2.49,4.27.71,2-3,5.7c0,0,2.51-.07,3.38,3.21s1,6.32-2.31,8.19c-2.52,1.42-8.52,2.84-10.62-3l-.07-.15a69.79,69.79,0,0,1-11.93,6.76c-5.7,2.32-14.79,2.14-14.79,2.14a10.56,10.56,0,0,1-6.77,4.28C82.05,126.08,63.55,116.8,63.55,116.8Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.05,102.17c.08-.06.87.84,1.25,2.68a11.32,11.32,0,0,1-1.07,7A21,21,0,0,1,95,117.54a8.72,8.72,0,0,1-2.25,1.86c-.09-.1.62-1,1.78-2.3a27.58,27.58,0,0,0,3.91-5.62A12.08,12.08,0,0,0,99.65,105C99.47,103.22,98.91,102.24,99.05,102.17Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M110,106.87s0,.2-.2.39a1.61,1.61,0,0,1-1.1.31,4.45,4.45,0,0,1-3-1.78,5.19,5.19,0,0,1-1.11-3.3c.06-.9.35-1.39.46-1.36s.08.55.19,1.33a6.14,6.14,0,0,0,1.18,2.76,4.77,4.77,0,0,0,2.38,1.7C109.47,107.13,109.85,106.8,110,106.87Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M101.08,84.21a2.62,2.62,0,0,1,2.26.18,5.76,5.76,0,0,1,2.12,1.7c.68.82,1.28,1.85,2,2.92a87.2,87.2,0,0,0,5.38,7.3c1.08,1.32,2.27,2.66,3.53,4a8,8,0,0,1,1.76,2.43,3.54,3.54,0,0,1-.34,3.21,10.7,10.7,0,0,1-2,2.28c-.72.65-1.45,1.28-2.18,1.87a34.27,34.27,0,0,1-4.46,3.16,5.35,5.35,0,0,1-2.58.71,5,5,0,0,1-2.43-.72,8.48,8.48,0,0,1-3.12-3.09,4.15,4.15,0,0,1-.28-3.62,2.7,2.7,0,0,1,2.15-1.7,2.3,2.3,0,0,1,1.68.4c.32.25.41.45.39.46a2.48,2.48,0,0,0-2-.5,2.27,2.27,0,0,0-1.73,1.53,3.59,3.59,0,0,0,.37,3.11,7.91,7.91,0,0,0,2.92,2.74,4.27,4.27,0,0,0,2.06.59,4.73,4.73,0,0,0,2.18-.65,35.83,35.83,0,0,0,4.29-3.11q1.06-.89,2.13-1.86A10.05,10.05,0,0,0,117,105.5a2.61,2.61,0,0,0,.28-2.41,7.5,7.5,0,0,0-1.57-2.15q-1.9-2.07-3.53-4.1a77,77,0,0,1-5.27-7.48c-.69-1.12-1.24-2.15-1.84-3a5.7,5.7,0,0,0-1.87-1.7A4.73,4.73,0,0,0,101.08,84.21Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M105.27,101.23c.1.06,0,.48-.39,1a4.84,4.84,0,0,1-4.77,1.73c-.67-.17-1-.43-1-.54s1.6.13,3.28-.51S105,101.1,105.27,101.23Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4,81a7.86,7.86,0,0,1,1.36,1.41c.83.94,2,2.33,3.45,4l5,6.08,2.94,3.61a27.86,27.86,0,0,1,3,4.11,5.55,5.55,0,0,1,.37,5.2,10.84,10.84,0,0,1-3.37,3.43c-2.39,1.78-4.4,3.49-6.38,4.71a6.63,6.63,0,0,1-3,1,4.36,4.36,0,0,1-2.31-.55c-1.17-.69-1.31-1.53-1.27-1.51a4.52,4.52,0,0,0,1.43,1.2,4.26,4.26,0,0,0,2.12.35,6.19,6.19,0,0,0,2.68-1c1.81-1.2,3.85-3,6.19-4.81a10.6,10.6,0,0,0,3.09-3.17,4.68,4.68,0,0,0-.38-4.37,28.31,28.31,0,0,0-2.88-4l-2.9-3.65-4.86-6.2c-1.38-1.78-2.48-3.23-3.22-4.24A8,8,0,0,1,110.4,81Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M118.12,82.83c.23-.16,3.14,4.33,8,8.64a29.72,29.72,0,0,1,3.33,3.3,9.33,9.33,0,0,1,1.82,3.45c.58,2.23-.17,3.6-.24,3.53a10.28,10.28,0,0,0-.38-3.34,9.55,9.55,0,0,0-1.85-3.09,34.7,34.7,0,0,0-3.29-3.16,37.93,37.93,0,0,1-5.67-6.29A10.29,10.29,0,0,1,118.12,82.83Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M129.83,108.58c0,.33-2.61,0-5.43,1a7.55,7.55,0,0,0-3.09,2.07c-.64.73-.88,1.32-1,1.28s-.08-.73.5-1.66a6.54,6.54,0,0,1,3.3-2.56,10,10,0,0,1,4.09-.49C129.22,108.27,129.84,108.46,129.83,108.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M72.62,211.79a9.65,9.65,0,0,1-1.23,3.05,37.47,37.47,0,0,1-10.11,12.09,9.66,9.66,0,0,1-2.78,1.75c-.17-.23,3.88-3.15,7.77-7.85S72.36,211.67,72.62,211.79Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.56 257.22 127.22 202.22 121.32 203.32 128.38 258.17 137.56 257.22",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.94,396.55s-13-88.2-12.95-101c0-5-2.68-38.16-2.68-38.16l-22.37,2L126.6,199.15s44.46-8,56.41-8.61,52.16,5.53,52.16,5.53l71.53,11.29s19.81,3.17,19.61,3l49.56,12.82-9.33,56.41L337,278.43l.19,35.67c-.39,2.7,1.93,16.19-15.81,37.78l-3,37.57,13.3,68.35H167.49Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M289.94,204.72c.15.09-.24,1.11-1.42,2.65a24.69,24.69,0,0,1-6.07,5.46,32.12,32.12,0,0,1-11.27,4.53c-1.13.17-2.29.41-3.48.54s-2.42.22-3.66.26-2.51,0-3.8,0l-3.9-.39a35.69,35.69,0,0,1-14-5.11,33.4,33.4,0,0,1-8.87-8.28,30.76,30.76,0,0,1-4-7.09c-.69-1.8-.84-2.87-.67-2.92s.64.87,1.59,2.48a43.25,43.25,0,0,0,4.5,6.39,35.16,35.16,0,0,0,8.7,7.38,35.64,35.64,0,0,0,13.1,4.57,45.49,45.49,0,0,0,14-.15,33.73,33.73,0,0,0,10.77-3.74,31.74,31.74,0,0,0,6.27-4.57C289.12,205.42,289.79,204.63,289.94,204.72Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M289.92,298.71c.28-.09,1.65,3.35,1.95,9.26a41.65,41.65,0,0,1-.81,10.32,42.6,42.6,0,0,1-12,22.11,41.81,41.81,0,0,1-8.22,6.31c-5.12,3-8.75,3.68-8.83,3.4s3.18-1.72,7.84-4.95A46.19,46.19,0,0,0,290,308C290.21,302.31,289.5,298.79,289.92,298.71Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76,381.87a5.74,5.74,0,0,1,2.71-4.5c24.06-15.92,42.19-51.22,44-81.1,0-1.7.1-3.43.16-5.17v0h0c1.39-42.72,7.68-94.54,13.33-108.35C146.64,157.22,182,154.82,182,154.82c46.91-3.35,55.28,32.69,60,65.52,2.94,20.41,14.29,93.33,14.29,93.33L247.65,317c-10.15,30.09-33,54.43-62.75,65.63-8.64,3.25-16,4.56-19.4,1.76a118,118,0,0,1-49.36,30c-7.57,2.31-15.51,3.85-23.4,3.11-5.11-.48-10.51-2.17-13.57-6.31a11.76,11.76,0,0,1,10.09-18.73C87.49,386.67,75.79,388.36,76,381.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.73,168.09l2.94-2.8,31.71,12.78a8.87,8.87,0,0,1,8.36,8.57L218.46,290c0,7-1.37,13.08-5.6,18.66l-4.45,5.88c-10.16,13.41-31,12.31-39.08-2.47a10.43,10.43,0,0,1-1.12-2.67,20.81,20.81,0,0,1-.48-2.31c-.94-8.31-1-15.52-1-15.52-.57-9.13-.76-12.87-.76-12.79s-19.42-2.23-24.67-27.16c-2.61-12.4-2.12-29.46-1.38-46.24C140.94,182.1,157.06,168.07,175.73,168.09Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.23,219.26a3.22,3.22,0,0,0,3.27,3.09,3.08,3.08,0,0,0,3.18-3.07,3.23,3.23,0,0,0-3.27-3.1A3.1,3.1,0,0,0,182.23,219.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.45,220.14a3.22,3.22,0,0,0,3.27,3.09,3.08,3.08,0,0,0,3.18-3.07,3.24,3.24,0,0,0-3.27-3.1A3.1,3.1,0,0,0,149.45,220.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.24,212c.42.4,2.77-1.53,6.24-1.7s6.1,1.45,6.45,1c.18-.2-.27-.93-1.41-1.69a8.92,8.92,0,0,0-5.19-1.31,8.53,8.53,0,0,0-5,1.87C143.36,211,143,211.8,143.24,212Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.44,212.34c.46.35,2.6-1.81,6-2.33s6.22.81,6.52.33c.16-.21-.36-.9-1.58-1.53a8.83,8.83,0,0,0-5.3-.78,8.51,8.51,0,0,0-4.72,2.37C178.46,211.37,178.22,212.18,178.44,212.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.32,237.58c0-.19-2.17-.46-5.68-.73-.89,0-1.74-.18-1.92-.78a4.48,4.48,0,0,1,.46-2.65c.73-2.19,1.48-4.48,2.28-6.88,3.16-9.78,5.39-17.81,5-17.93s-3.28,7.7-6.43,17.49q-1.14,3.61-2.17,6.91a5.15,5.15,0,0,0-.28,3.5,2.22,2.22,0,0,0,1.52,1.22,6,6,0,0,0,1.51.13C164.14,237.87,166.32,237.78,166.32,237.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,278.74a64,64,0,0,0,33.21-10.66s-7.59,17.82-32.86,16.73Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.21,245.87a6.23,6.23,0,0,1,5.48-2.6,5.68,5.68,0,0,1,4.05,1.91,3.62,3.62,0,0,1,.48,4.12c-.87,1.37-2.81,1.77-4.49,1.38a13.21,13.21,0,0,1-4.56-2.42,4.1,4.1,0,0,1-1-1,1.17,1.17,0,0,1-.06-1.29",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.65,239.47c-.57,0-.39,3.76-3.47,6.59s-7.12,2.62-7.12,3.15c0,.24.93.69,2.62.65a9.42,9.42,0,0,0,6-2.41,8.2,8.2,0,0,0,2.67-5.52C177.37,240.35,176.9,239.44,176.65,239.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.12,198.82c.48.88,3.84-.09,7.94-.22s7.53.46,7.93-.45c.18-.44-.52-1.23-2-1.94a13.79,13.79,0,0,0-12.1.52C175.54,197.55,174.9,198.4,175.12,198.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.74,197.08c.65.75,3-.18,5.87-.37s5.33.27,5.85-.59c.23-.41-.2-1.18-1.3-1.87a8.51,8.51,0,0,0-9.44.77C143.74,195.88,143.45,196.7,143.74,197.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.1,230.74s-17.76,5.53-27.81-38.32c-3.44-15-17.34-27.13-17.34-27.13l5.64-1.69s35,9.87,35.62,10.31S223,192,223,192Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.72,229.1c-.08-1.87,1.86-6.39,3.69-6.77,4.9-1,13.81-1.07,14.53,11.46,1,17.13-16.43,14.58-16.49,14.09S214,235.57,213.72,229.1Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.32,241.09c.07-.06.31.19.82.39a3,3,0,0,0,2.24-.08c1.77-.76,3.13-3.72,3-6.81a10,10,0,0,0-1.08-4.23A3.44,3.44,0,0,0,223,228.2a1.52,1.52,0,0,0-1.72.91c-.2.5-.07.83-.16.87s-.39-.27-.29-1a1.94,1.94,0,0,1,.61-1.12,2.32,2.32,0,0,1,1.63-.53,4.23,4.23,0,0,1,3.27,2.48,10.26,10.26,0,0,1,1.3,4.72c.09,3.46-1.49,6.79-3.93,7.64a3.17,3.17,0,0,1-2.76-.3C220.37,241.5,220.26,241.12,220.32,241.09Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05,222.35a22.6,22.6,0,0,1-2.56-.52,15.41,15.41,0,0,1-6.1-3.54,20.85,20.85,0,0,1-3.18-3.72,28.38,28.38,0,0,1-2.59-5,106.49,106.49,0,0,1-3.69-12.46c-1.2-4.46-2.51-8.68-3.94-12.43a70.21,70.21,0,0,0-4.47-9.68,50.83,50.83,0,0,0-3.92-6c-.5-.68-.94-1.17-1.23-1.52a3.43,3.43,0,0,0-.45-.5,4.33,4.33,0,0,0,.38.56c.26.36.68.87,1.16,1.57a58.12,58.12,0,0,1,3.78,6.06,76.36,76.36,0,0,1,4.36,9.67c1.4,3.75,2.69,7.95,3.89,12.41a102.39,102.39,0,0,0,3.74,12.5,29,29,0,0,0,2.66,5.06,21.08,21.08,0,0,0,3.28,3.75,15.29,15.29,0,0,0,6.27,3.48A9.26,9.26,0,0,0,206.05,222.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.47,295.44a6.38,6.38,0,0,0,.18-.83c.11-.6.25-1.41.43-2.43.37-2.2.89-5.33,1.54-9.3l-.41-.06c-.09.62-.18,1.31-.28,2l0-.06c-.11.23-.24.49-.36.77l.43.15a164.87,164.87,0,0,0,5.49-27.57,168.77,168.77,0,0,0,1.05-17.84c-.06-6.26,0-12.91-1.69-19.55a31.28,31.28,0,0,0-3.12-7.78,41.69,41.69,0,0,0-4.74-6.59c-3.48-4-7.23-7.49-10.66-10.92L199,177.35,186.51,165.2l-3.41-3.27-.9-.84a1.47,1.47,0,0,0-.32-.27,1.63,1.63,0,0,0,.27.33l.84.89c.8.81,1.91,1.94,3.31,3.38l12.27,12.33c5.22,5.19,11.4,11.36,18.27,18.21,3.42,3.45,7.16,6.93,10.59,10.9a33.81,33.81,0,0,1,7.68,14.07c1.64,6.5,1.62,13.12,1.69,19.36a170.56,170.56,0,0,1-1,17.76,172.76,172.76,0,0,1-5.24,27.53l.43.16c.12-.28.24-.54.34-.78l0,0v0c.09-.71.18-1.4.25-2l-.41-.06c-.57,4-1,7.13-1.35,9.33-.13,1-.24,1.85-.32,2.45A4.19,4.19,0,0,0,229.47,295.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,216.25a2.8,2.8,0,0,0-.3-.73c-.27-.53-.6-1.2-1-2-.87-1.74-2.24-4.21-4-7.2s-4.08-6.47-6.78-10.21-5.89-7.69-9.44-11.66-7.19-7.52-10.6-10.63-6.64-5.73-9.43-7.83-5.09-3.73-6.73-4.77l-1.9-1.21a2.86,2.86,0,0,0-.69-.38,3.1,3.1,0,0,0,.6.51c.49.36,1.09.79,1.81,1.33,1.59,1.12,3.84,2.81,6.57,5s5.89,4.82,9.28,7.92S217.26,181,220.82,185s6.69,7.89,9.44,11.57,5.05,7.12,6.89,10.07,3.29,5.36,4.23,7.06l1.13,1.94A3.46,3.46,0,0,0,243,216.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,354.32a10.73,10.73,0,0,0,1.18-1.71c.72-1.12,1.75-2.75,3.07-4.73a172.79,172.79,0,0,1,11-14.93,84.42,84.42,0,0,1,13.14-13,71.77,71.77,0,0,1,6.45-4.17,10.43,10.43,0,0,0-1.93.78,17.81,17.81,0,0,0-2.14,1.17,28.63,28.63,0,0,0-2.7,1.77,75.87,75.87,0,0,0-13.42,13,138.6,138.6,0,0,0-10.91,15.13c-1.26,2-2.22,3.7-2.86,4.87A10.91,10.91,0,0,0,220.12,354.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.31,439.36,262.7,312.94l-29-15.49c-.6-.87-15.27-7.49-15.27-7.49a54.5,54.5,0,0,1-15,15.88c-17.56,10.6-35.18,1.94-36.68-14.31h0l-16.08,4.52-31,5.35s-25.29,65.9-21.94,91.68-1.32,70.39-1.32,70.39l-2.61,14.75,26.39.54h4.34l58.86-.33,51.37-.21C228.68,460.8,234.31,439.36,234.31,439.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.34,450.06a27.22,27.22,0,0,1-24.91-13.63A19.41,19.41,0,0,1,48.8,427c0-13.73,8.55-33.42,11.39-40.51,4.09-10.22,43.08-81,47.77-80s7.24,1.37,7.24,1.37L93,408.56l70.61,11.58-7.75,27Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.51,343.49l35.88,19,11.86-61.13s-15.2,1.37-20.22,7.75S74.51,343.49,74.51,343.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,412.66l-9.67-21-4.22-15.52-12.85-10s-4.26.5-2.94,3.81,7.78,9.26,7.78,9.26l3.8,10.61-6.18-10.78-9-4.46-8.93.66s-1.65,4,2.49,4.13h4.46l6.78,5.46,4.24,10.25-6.39-9.92-9.43-3.35-6,1.53s-1.65,2.65,1.32,3,5,.33,5,.33l5.45,3.17,4.8,10.06L80.07,393l-10.91-1.3s-1.82,2.63,1,3.62a91.17,91.17,0,0,1,8.44,4l6.07,8.39Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,412.66l-33.38-4.84h-.07l0-.06-6.1-8.38.07.05c-1.91-1-3.9-2-6-2.94-.53-.23-1.06-.47-1.6-.68a8.49,8.49,0,0,1-1.65-.74,2,2,0,0,1-.88-1.69,3.56,3.56,0,0,1,.61-1.82l.06-.1h.14l10.91,1.29h.07l0,0,8.44,6.94-.36.28-4.81-10,.1.1-5.46-3.17.13,0c-1.45,0-2.94-.12-4.47-.28a2.87,2.87,0,0,1-2.27-.92,1.75,1.75,0,0,1-.22-1.31,4,4,0,0,1,.46-1.18l0-.09.1,0,6-1.54h.08l.07,0L87.44,385l.08,0,0,.07L94,395l-.45.24-2.28-5.49c-.65-1.6-1.31-3.18-2-4.76l.08.1-6.78-5.46.16.06H80.09a16.85,16.85,0,0,1-2.64-.09,2.56,2.56,0,0,1-2.12-1.7,4.29,4.29,0,0,1,.21-2.7l0-.14.17,0,8.93-.66h.07l.06,0,9,4.47.06,0,0,.07,6.18,10.78-.44.2L95.9,379.32l.06.1a57.48,57.48,0,0,1-6.26-6.78,16.4,16.4,0,0,1-1.23-1.88,4,4,0,0,1-.57-2.21,2.47,2.47,0,0,1,1.28-1.86,5.59,5.59,0,0,1,2.08-.71h.08l.07,0,12.83,10,.05,0v.06l4.19,15.53v0L118,412.66l-9.8-20.93h0L104,376.19l.07.1-12.86-9.94.15,0a5.34,5.34,0,0,0-1.91.65,2.06,2.06,0,0,0-1.08,1.55c-.07,1.34.9,2.62,1.73,3.79a57.19,57.19,0,0,0,6.22,6.7l0,0,0,.05,3.81,10.61-.43.2-6.19-10.77.11.09-9-4.46.13,0-8.93.66.22-.15a3.78,3.78,0,0,0-.19,2.34,2,2,0,0,0,1.72,1.35,17.92,17.92,0,0,0,2.56.08h2.71l.07.06,6.78,5.46.06,0,0,.06,2,4.76c.77,1.88,1.55,3.75,2.27,5.49l-.46.24-6.39-9.92.13.1-9.42-3.35H78l-6,1.53.16-.11a2,2,0,0,0-.25,2,1.33,1.33,0,0,0,.81.52,6,6,0,0,0,1.09.18c1.51.15,3,.25,4.42.27h.06l.06,0,5.45,3.17.07,0,0,.07,4.79,10.06.45.95-.81-.67-8.43-7,.12,0-10.91-1.31.19-.09a3.28,3.28,0,0,0-.54,1.58,1.56,1.56,0,0,0,.7,1.36,9.41,9.41,0,0,0,1.57.69c.55.22,1.08.46,1.61.69,2.1,1,4.1,2,6,3l0,0,0,0,6.06,8.4-.11-.07Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M234.89,447.34s-8.2,17.18-18.85,22.21c-9.89,4.67-16.17,5.68-27.94,4.82-5.75-.41-24.49-4.05-31.27-6l-45.67-19.6,96,15.13Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M258.32,319.21s17.18-6.09,17.51,32.42S231,454.77,223.26,461.13s-16.5,10.64-39.71,7.2c-29.11-4.31-70.91-19.55-70.91-19.55L138.21,425l51.9-2.34,42.19-86.73S243.92,317.53,258.32,319.21Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.86,447.12s12.87,8.1,27.4,7.68,27.39,4.28,29.26,3,2.08-3.59,0-4.63-10.87-2.28-10.87-2.28l-7.6-3.12S220,450,222.07,449s4.15-2.49,3.32-4.77a3.26,3.26,0,0,0-2.91-2.29s5.61.21,5.4-2.07a7.16,7.16,0,0,0-3.11-4.78c-.83-.41-11.72-4.84-11.72-4.84l-14-2.78,13.44-.54,11.74,3.28s4.69.53,3.65-3.42-15.37-8.3-15.37-8.3l-18.26-1.26s14.11-2.06,15.56-6.42-1-6.85-1-6.85-10,3.95-14.74,4.78-10.58,2.69-18.26,5.81a123.13,123.13,0,0,0-12.18,5.6",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.61,420.14l.74-.42c.49-.27,1.23-.66,2.21-1.15,2-1,4.88-2.35,8.72-3.94a126.4,126.4,0,0,1,14.29-5.06c1.42-.38,2.92-.73,4.48-1a39.69,39.69,0,0,0,4.69-1.23c3.19-1,6.52-2.2,10-3.55l.12,0,.08.09a6.79,6.79,0,0,1,1.47,5.5l-.15.74-.2.73a3.68,3.68,0,0,1-.81,1.34,9.2,9.2,0,0,1-2.54,1.79,31.07,31.07,0,0,1-6,2.16,62.2,62.2,0,0,1-6.44,1.36l0-.44,18.27,1.24h.05a67.71,67.71,0,0,1,10.95,4.4,21,21,0,0,1,2.58,1.62,8.88,8.88,0,0,1,1.17,1.05,3.55,3.55,0,0,1,.84,1.39,3.86,3.86,0,0,1,.1,1.63,2.18,2.18,0,0,1-.86,1.44,4.89,4.89,0,0,1-3.15.67h0l-11.75-3.27h.08l-13.44.54,0-.51,10,2,4,.79h.05l11.67,4.83a6.72,6.72,0,0,1,2.27,2.26,5.43,5.43,0,0,1,1,3,1.74,1.74,0,0,1-1.05,1.34,5.33,5.33,0,0,1-1.51.49,14.55,14.55,0,0,1-3.08.24v-.51a3.41,3.41,0,0,1,2.42,1.19,3.71,3.71,0,0,1,.92,2.49,3.42,3.42,0,0,1-1.25,2.32,9.67,9.67,0,0,1-2.13,1.4,2,2,0,0,1-.64.25,3.65,3.65,0,0,1-.64.09c-.42.05-.84.06-1.25.07-.83,0-1.65,0-2.47,0-1.64,0-3.26-.1-4.86-.18C206.16,449,200,448.49,194,448l.11-.45,7.59,3.12,0,0c2.8.42,5.52.87,8.17,1.47.66.16,1.32.32,2,.54a3.91,3.91,0,0,1,1.79,1.05,2.41,2.41,0,0,1,.58,2,3.27,3.27,0,0,1-1,1.79,3.9,3.9,0,0,1-.38.33,1.77,1.77,0,0,1-.47.28,3.24,3.24,0,0,1-1,.12,13.17,13.17,0,0,1-1.91-.17c-1.25-.17-2.46-.41-3.66-.63-2.39-.45-4.72-.89-7-1.25a90.5,90.5,0,0,0-12.74-1.21c-1,0-2,0-2.91,0s-1.89,0-2.8,0-1.8-.12-2.67-.21l-2.51-.35a57.53,57.53,0,0,1-14.54-4.65c-1.6-.76-2.79-1.4-3.58-1.85s-1.18-.73-1.18-.73a3.48,3.48,0,0,1,.31.17l.9.49c.81.43,2,1.06,3.61,1.79a58.53,58.53,0,0,0,14.52,4.52l2.5.33c.86.09,1.75.13,2.65.2s1.83,0,2.78,0,1.93,0,2.92,0a89.24,89.24,0,0,1,12.8,1.17c2.27.35,4.6.78,7,1.23,1.2.22,2.41.45,3.64.62a14.59,14.59,0,0,0,1.86.16,3.12,3.12,0,0,0,.88-.11,2.36,2.36,0,0,0,.69-.51,2.92,2.92,0,0,0,.86-1.56,2,2,0,0,0-.49-1.65,3.5,3.5,0,0,0-1.61-.93c-.62-.21-1.27-.36-1.92-.52-2.62-.59-5.35-1-8.13-1.44h-.06L194,448l-1.4-.57,1.51.12c5.93.5,12.12,1,18.53,1.31,1.6.08,3.22.15,4.85.18.81,0,1.63,0,2.44,0,.41,0,.82,0,1.22-.06a5.4,5.4,0,0,0,.58-.09,1.5,1.5,0,0,0,.51-.2,9.75,9.75,0,0,0,2-1.33,2.94,2.94,0,0,0,1.09-2,3.26,3.26,0,0,0-.81-2.14,2.91,2.91,0,0,0-2-1v-.51a14.76,14.76,0,0,0,3-.23,4.78,4.78,0,0,0,1.37-.44,1.27,1.27,0,0,0,.78-.94,5,5,0,0,0-1-2.7,6.43,6.43,0,0,0-2.07-2.08L213,430.49h0l-4-.79-10-2-2.15-.43,2.19-.09,13.44-.53h.08L224.31,430h0a4.31,4.31,0,0,0,2.8-.57,2.26,2.26,0,0,0,.57-2.53,4.85,4.85,0,0,0-1.82-2.17,19.24,19.24,0,0,0-2.51-1.58,66.87,66.87,0,0,0-10.86-4.38h.06l-18.27-1.27-2-.14,2-.31a64.51,64.51,0,0,0,6.39-1.33,31.52,31.52,0,0,0,5.88-2.12,9,9,0,0,0,2.43-1.69,3.29,3.29,0,0,0,.72-1.2l.21-.69.13-.71a6.38,6.38,0,0,0-1.34-5.17l.21,0c-3.48,1.34-6.81,2.54-10,3.53a42.91,42.91,0,0,1-4.74,1.22c-1.55.27-3,.61-4.46,1a124.1,124.1,0,0,0-14.28,5c-3.85,1.55-6.78,2.9-8.75,3.84l-2.24,1.1Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.72,437.84a31.58,31.58,0,0,0,4.36.34c2.68.16,6.39.47,10.44,1.09s7.69,1.41,10.3,2.05a30.18,30.18,0,0,0,4.26,1,20.13,20.13,0,0,0-4.11-1.5,76.72,76.72,0,0,0-10.33-2.3,78,78,0,0,0-10.54-.87A19.79,19.79,0,0,0,194.72,437.84Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.74,363.23c-.54,2.51-1,4.6-1.32,6.2a14.13,14.13,0,0,0-.38,2.29,12.68,12.68,0,0,0,.68-2.23c.4-1.58.92-3.65,1.55-6.13,1.29-5.19,3-12.37,4.85-20.32,3-13,5.49-24.07,6.13-27.51l0-.27-.22.15a6.19,6.19,0,0,0-1.08.82,6.39,6.39,0,0,0,1.2-.63l-.17-.12c-1,3.36-3.63,14.35-6.67,27.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.2,366.18l58,25.85s22.51-69.47-10.65-80.66l-16.63,3.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.34,
    y1: 450.06,
    x2: 155.86,
    y2: 447.12,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.86,447.12c0,.15-17.79.92-39.75,1.73s-39.77,1.35-39.77,1.21,17.79-.92,39.75-1.73S155.86,447,155.86,447.12Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.66,407.65c0,.09-1.14.2-2.93.64a22.17,22.17,0,0,0-6.55,2.86,17.75,17.75,0,0,0-5.12,5c-1,1.53-1.39,2.63-1.48,2.6a2.68,2.68,0,0,1,.2-.79,10.64,10.64,0,0,1,1-2,16.18,16.18,0,0,1,5.14-5.18,19.83,19.83,0,0,1,6.76-2.79,18.35,18.35,0,0,1,2.2-.29A2.22,2.22,0,0,1,84.66,407.65Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.2,357.93a2,2,0,0,1-.17.55l-.58,1.52c-.51,1.31-1.29,3.2-2.28,5.53-2,4.65-4.88,11-8.3,17.91s-6.69,13.09-9.1,17.53c-1.2,2.22-2.19,4-2.89,5.24l-.81,1.41a2.53,2.53,0,0,1-.31.47,2.37,2.37,0,0,1,.22-.52l.72-1.46c.69-1.32,1.61-3.12,2.75-5.31,2.32-4.49,5.53-10.68,9-17.59s6.36-13.22,8.43-17.83l2.43-5.46.68-1.48A2.84,2.84,0,0,1,221.2,357.93Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373,430.48s-24.78-28.52-34.13-57S334,348.2,334,348.2s12.62,27.7,22.21,41.08,26.64,33,26.64,33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,352.64a1.44,1.44,0,0,0-2.68.92c1.51,10,4.77,33.53,4.64,48.77-.16,19.81,0,27.46,0,27.46h10.31s-1.83-40.94-4.16-53.42C384.45,367.62,381,357.9,378,352.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.59,426.46a109,109,0,0,0,8.48-30.79c.85-7.29-.66-17.14-2.92-30.29a81.13,81.13,0,0,1-1.3-14.57,2.46,2.46,0,0,1,4.62-1.15c1.24,2.22,4.85,9.8,5.76,14.56,2.5,13,5.33,19.47,3.16,31.79s-10.15,31.29-10.15,31.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.87,427.3s27.21-58.47,29.09-67.14,8.3-28.66,9.05-27.53,1.89,11.69-3,23.76-25.84,72.69-25.84,72.69h-9.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.61,424.68a5.08,5.08,0,0,1-.77-.52c-.48-.37-1.21-.88-2.1-1.61-1.81-1.43-4.35-3.59-7.31-6.46a122.53,122.53,0,0,1-19.74-25.33,165.54,165.54,0,0,1-13.47-29.18c-1.37-3.88-2.37-7.06-3-9.27-.33-1.1-.56-2-.72-2.55a6.08,6.08,0,0,1-.21-.9,5.38,5.38,0,0,1,.32.87c.21.62.48,1.46.83,2.51.71,2.19,1.77,5.34,3.18,9.2a177.09,177.09,0,0,0,13.59,29,128.18,128.18,0,0,0,19.52,25.33c2.92,2.89,5.41,5.1,7.17,6.57.87.76,1.58,1.3,2,1.69A5.67,5.67,0,0,1,380.61,424.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.58,396.63a10,10,0,0,1-.24-1.71c-.13-1.21-.3-2.79-.5-4.69-.43-4-1.11-9.41-2.07-15.4s-2-11.38-2.86-15.27c-.41-1.87-.74-3.42-1-4.61a9.78,9.78,0,0,1-.3-1.71,10,10,0,0,1,.52,1.66c.31,1.07.71,2.63,1.18,4.57.93,3.87,2.07,9.26,3,15.27s1.57,11.48,1.9,15.45c.16,2,.27,3.6.31,4.71A10,10,0,0,1,383.58,396.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,349.2a6.79,6.79,0,0,1,.32.74c.2.55.47,1.27.81,2.17s.78,2.1,1.17,3.48.93,2.92,1.32,4.68c.22.88.44,1.8.68,2.75s.39,2,.59,3c.45,2.08.72,4.33,1,6.69a100.13,100.13,0,0,1-1.1,30.9c-.5,2.34-.94,4.56-1.53,6.6-.28,1-.52,2-.81,3l-.87,2.69c-.52,1.73-1.15,3.24-1.66,4.58s-1,2.47-1.41,3.38-.72,1.58-1,2.11a3.62,3.62,0,0,1-.37.72,3.71,3.71,0,0,1,.27-.77l.86-2.14c.4-.93.86-2.07,1.32-3.42s1.08-2.86,1.57-4.58c.26-.86.54-1.76.83-2.7s.5-1.93.77-2.95c.57-2,1-4.25,1.47-6.58a103.36,103.36,0,0,0,1.1-30.74c-.31-2.35-.57-4.59-1-6.66-.2-1-.35-2.05-.56-3s-.43-1.87-.64-2.75c-.36-1.76-.86-3.31-1.23-4.68s-.75-2.55-1.07-3.51-.53-1.64-.71-2.2A4,4,0,0,1,390,349.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.7,333.81a1,1,0,0,1,0,.26c0,.21-.07.46-.12.76-.12.67-.27,1.65-.54,2.91-.52,2.52-1.4,6.13-2.76,10.52s-3.21,9.55-5.42,15.2-4.74,11.83-7.16,18.39-4.34,12.95-6.11,18.76-3.43,11-5,15.32a98.43,98.43,0,0,1-4.3,10c-.56,1.16-1.06,2-1.38,2.62-.15.27-.28.48-.38.67s-.14.22-.15.21a1.35,1.35,0,0,1,.1-.24c.09-.19.19-.42.33-.7.29-.61.75-1.49,1.28-2.66,1.09-2.31,2.57-5.72,4.11-10s3.18-9.52,4.91-15.34,3.63-12.23,6.09-18.8,5-12.74,7.21-18.38,4.12-10.76,5.52-15.13,2.34-7.95,2.93-10.45c.3-1.25.49-2.22.64-2.88.08-.3.13-.55.18-.75A.76.76,0,0,1,430.7,333.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.82,320.9a2.34,2.34,0,0,0-3.86,2.38,66,66,0,0,0,3.42,8.79c3.74,7.95,14.72,36.47,19.87,52.13s12.39,44.88,12.39,44.88l11-1.78s-10.05-48-19.87-65.31C361.87,348.09,354,328,346.82,320.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.25,394a6.79,6.79,0,0,1,.57,1.32c.32.86.77,2.12,1.26,3.69,1,3.13,2.25,7.5,3.5,12.36s2.28,9.29,3,12.5l.83,3.8a8.23,8.23,0,0,1,.23,1.42,6.61,6.61,0,0,1-.45-1.36l-1-3.77L374,411.51c-1.25-4.86-2.42-9.24-3.33-12.4l-1.09-3.73A6.58,6.58,0,0,1,369.25,394Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.15,428.19a1.21,1.21,0,0,1-.06-.3c0-.23-.07-.51-.12-.86-.12-.76-.22-1.89-.45-3.33-.41-2.88-1.13-7-2.31-12.11a172.25,172.25,0,0,0-5.14-17.54c-2.25-6.51-5.07-13.54-8.28-20.81-6.46-14.54-12.91-27.43-17.15-37-2.14-4.75-3.8-8.63-4.9-11.34-.55-1.35-.95-2.41-1.23-3.12l-.31-.82a1.19,1.19,0,0,1-.08-.29,1.16,1.16,0,0,1,.14.27c.09.21.21.47.36.79l1.33,3.08c1.16,2.68,2.87,6.53,5.06,11.26,4.34,9.48,10.85,22.34,17.32,36.89,3.2,7.29,6,14.34,8.25,20.87a163,163,0,0,1,5,17.63,122.13,122.13,0,0,1,2.13,12.17c.2,1.45.26,2.58.34,3.35,0,.35.05.64.07.87A1.2,1.2,0,0,1,384.15,428.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.62,427.3a12,12,0,0,1-.37-1.85l-.86-5.05c-.76-4.25-1.91-10.11-3.57-16.49s-3.5-12.06-4.92-16.14l-1.72-4.83a13.05,13.05,0,0,1-.59-1.79,12.09,12.09,0,0,1,.8,1.71c.47,1.12,1.13,2.74,1.89,4.77a159.07,159.07,0,0,1,5.1,16.13,168.69,168.69,0,0,1,3.42,16.58c.31,2.14.55,3.87.67,5.08A12.26,12.26,0,0,1,389.62,427.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.29,
    y: 425.72,
    width: 42.86,
    height: 52.22,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 369.29,
    y: 425.72,
    width: 42.86,
    height: 52.22
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 360.45,
    y: 425.72,
    width: 38.03,
    height: 52.22,
    style: {
      fill: "#D175F7"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC21);
export default __webpack_public_path__ + "static/media/c21.de58f2cefd3614c940d755484416068a.svg";
export { ForwardRef as ReactComponent };